import Button from './Button';

export default Button;



// WEBPACK FOOTER //
// ./app/javascript/common/components/Button/index.js